import React from "react";
import { Route } from "react-router-dom";
import { SignIn } from "../pages/auth/signin/SignIn";
import { Splash } from "../pages/splash/Splash";
import { UserType } from "../pages/auth/usertype/UserType";
import { SignUp } from "../pages/auth/signup/SignUp";
import { PricingPlan } from "../pages/pricing/PricingPlan";
import { Checkout } from "../pages/checkout/Checkout";
import PublicRoutes from "../routes/PublicRoutes";
import Logout from "../pages/auth/signin/Logout";
import NotFoundPage from "../pages/error/NotFoundPage";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";



const stripePromise = loadStripe("pk_test_51Q3JqXAk3rPClgNeNUhwblAMcUHZGovpvDdkpJQfpTiriYMkBw8bC4a0boU4TjU8tWhgkECwPQmw8oCgIvA0yLKE00ZWdMIpNm");

export const WebRoutes = () => (
  <>
    <Route element={<PublicRoutes />}>
      <Route path="/" element={<Splash />} />
      <Route path="/login" element={<SignIn />} />
      <Route path="/signup/:role" element={<SignUp />} />
      <Route path="/user-type" element={<UserType />} />
      <Route path="/pricing/:role/:userId" element={<PricingPlan />} />


      <Route
        path="/checkout/:userId/:planId/:role"
        element={
          <Elements stripe={stripePromise}>
            <Checkout />
          </Elements>
        }
      />
      <Route
        path="/checkout"
        element={
          <Elements stripe={stripePromise}>
            <Checkout />
          </Elements>
        }
      />
    </Route>

    <Route path="/logout" element={<Logout />} />
    <Route path="*" element={<NotFoundPage />} />
  </>
);
